<template>
    <div>
        <v-navigation-drawer v-model="drawer" right fixed app :width="drawerWidth" class="sidebar-drawer">
            <!-- Logo / Brand -->
            <div class="sidebar-brand">
                <div class="brand-icon">
                    <span style="font-size: 32px; line-height: 1;">🥛</span>
                </div>
                <transition name="fade">
                    <div v-if="!collapsed" class="brand-text">
                        <span class="brand-title">חלוקת חלב</span>
                        <span class="brand-subtitle">מערכת ניהול</span>
                    </div>
                </transition>
                <!-- כפתור סגירה/כיווץ — בדסקטופ כווץ, במובייל סגור -->
                <v-btn icon small class="collapse-btn" @click="toggleDrawer">
                    <v-icon size="18" color="rgba(255,255,255,0.85)">
                        {{ isMobile ? 'mdi-close' : (collapsed ? 'mdi-chevron-left' : 'mdi-chevron-right') }}
                    </v-icon>
                </v-btn>
            </div>

            <!-- User Info -->
            <div class="sidebar-user" @click="openAccountDetails()" role="button">
                <v-avatar size="36" color="rgba(255,255,255,0.25)" class="flex-shrink-0">
                    <v-icon size="20" color="white">mdi-account</v-icon>
                </v-avatar>
                <transition name="fade">
                    <div v-if="!collapsed" class="user-details">
                        <span class="user-name">{{ userName }}</span>
                        <span class="user-email">{{ email }}</span>
                    </div>
                </transition>
            </div>

            <div class="sidebar-divider"></div>

            <!-- Navigation Items -->
            <nav class="sidebar-nav">
                <div v-for="item in tables" :key="item.name" class="nav-item"
                    :class="{ active: activeItem === item.name }" @click="showTable(item.name)">
                    <div class="nav-icon-wrap">
                        <v-icon size="20" :color="activeItem === item.name ? 'white' : 'rgba(255,255,255,0.75)'">
                            {{ getItemIcon(item.name) }}
                        </v-icon>
                    </div>
                    <transition name="fade">
                        <span v-if="!collapsed" class="nav-label">{{ item.name }}</span>
                    </transition>
                    <div v-if="activeItem === item.name && !collapsed" class="active-indicator"></div>
                </div>
            </nav>

            <template v-slot:append>
                <div class="sidebar-divider"></div>
                <div class="nav-item logout-item" @click="logOut()">
                    <div class="nav-icon-wrap">
                        <v-icon size="20" color="rgba(255,255,255,0.75)">mdi-logout-variant</v-icon>
                    </div>
                    <transition name="fade">
                        <span v-if="!collapsed" class="nav-label">יציאה</span>
                    </transition>
                </div>
            </template>
        </v-navigation-drawer>
    </div>
</template>

<script>
import Auth from '@/services/auth.service.js'

const ROUTE_TO_TABLE = {
    dashboard: 'דאשבורד',
    users: 'משתמשים',
    customers: 'לקוחות',
    products: 'מלאי',
    orders: 'הזמנות',
    reports: 'דוחות',
}

export default {
    props: {
        tableListArray: Array,
    },
    data: () => ({
        userName: "",
        email: "",
        tables: [],
        collapsed: false,
        drawer: true,
        activeItem: null,
    }),
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.mdAndDown;
        },
        drawerWidth() {
            if (this.collapsed && !this.isMobile) return 68;
            return 240;
        },
    },
    watch: {
        $route(to) {
            this.activeItem = ROUTE_TO_TABLE[to.name] || null;
        },
        isMobile(val) {
            // כשעוברים לדסקטופ — פותחים ומאפסים collapse
            if (!val) {
                this.drawer = true;
                this.collapsed = false;
            } else {
                // כשעוברים למובייל — סוגרים
                this.drawer = false;
                this.collapsed = false;
            }
        },
    },
    methods: {
        toggleDrawer() {
            if (this.isMobile) {
                this.drawer = false;
            } else {
                this.collapsed = !this.collapsed;
            }
        },
        showTable(name) {
            this.activeItem = name;
            this.$emit("showTable", name);
            if (this.isMobile) this.drawer = false;
        },
        getUserDetails() {
            this.userName = Auth.getUserName();
            this.email = Auth.getUserEmail();
        },
        logOut() {
            localStorage.removeItem("token");
            this.$router.replace({ name: "login" });
        },
        openAccountDetails() {
            this.activeItem = null;
            this.$emit("showAccountDetails");
            if (this.isMobile) this.drawer = false;
        },
        getItemIcon(name) {
            const icons = {
                'דאשבורד': 'mdi-view-dashboard',
                'משתמשים': 'mdi-shield-account',
                'לקוחות': 'mdi-account-group',
                'מלאי': 'mdi-package-variant-closed',
                'הזמנות': 'mdi-cart-outline',
                'דוחות': 'mdi-chart-bar',
            };
            return icons[name] || 'mdi-circle-small';
        },
    },
    mounted() {
        this.tables = this.tableListArray;
        this.getUserDetails();
        this.activeItem = ROUTE_TO_TABLE[this.$route.name] || null;
        if (this.isMobile) this.drawer = false;
    },
}
</script>

<style scoped>
.sidebar-drawer {
    background: linear-gradient(180deg, #1a9ad6 0%, #0e81c4 40%, #0a6ba3 100%) !important;
    direction: rtl;
}

/* Brand */
.sidebar-brand {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 20px 14px 16px;
    min-height: 72px;
}

.brand-icon {
    width: 44px;
    height: 44px;
    background: rgba(255, 255, 255, 0.25);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.brand-text {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    white-space: nowrap;
    flex: 1;
}

.brand-title {
    color: white;
    font-weight: 700;
    font-size: 1rem;
    line-height: 1.2;
}

.brand-subtitle {
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.75rem;
}

.collapse-btn {
    flex-shrink: 0;
    opacity: 0.85;
    transition: opacity 0.2s;
}

.collapse-btn:hover {
    opacity: 1;
}

/* User */
.sidebar-user {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    margin: 4px 10px;
    border-radius: 12px;
    cursor: pointer;
    transition: background 0.2s;
    overflow: hidden;
    min-height: 56px;
}

.sidebar-user:hover {
    background: rgba(255, 255, 255, 0.12);
}

.user-details {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    white-space: nowrap;
    flex: 1;
}

.user-name {
    color: white;
    font-weight: 600;
    font-size: 0.875rem;
    overflow: hidden;
    text-overflow: ellipsis;
}

.user-email {
    color: rgba(255, 255, 255, 0.65);
    font-size: 0.72rem;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Divider */
.sidebar-divider {
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    margin: 8px 14px;
}

/* Nav */
.sidebar-nav {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 8px 10px;
}

.nav-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 11px 10px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;
    white-space: nowrap;
    min-height: 48px;
}

.nav-item:hover {
    background: rgba(255, 255, 255, 0.12);
}

.nav-item.active {
    background: rgba(255, 255, 255, 0.22);
}

.nav-icon-wrap {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-radius: 8px;
    transition: background 0.2s;
}

.nav-item.active .nav-icon-wrap {
    background: rgba(255, 255, 255, 0.2);
}

.nav-label {
    color: rgba(255, 255, 255, 0.82);
    font-size: 0.9rem;
    font-weight: 500;
}

.nav-item.active .nav-label {
    color: white;
    font-weight: 600;
}

.active-indicator {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 24px;
    background: white;
    border-radius: 0 3px 3px 0;
}

/* Logout */
.logout-item {
    margin: 0 10px 16px;
}

.logout-item:hover .nav-icon-wrap {
    background: rgba(239, 68, 68, 0.2);
}

.logout-item:hover .nav-label {
    color: #fca5a5 !important;
}

/* Fade */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.15s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>